/* Recharge */
function addCustomHTMLToWidget(widget, observer) {
    const widgetParentContainer = widget.closest('[data-recharge-container]');
    const widgetSettingsEl = widgetParentContainer ? widgetParentContainer.querySelector('.recharge_settings_json') : null;

    if (widgetSettingsEl) {
        const settings = JSON.parse(widgetSettingsEl.innerHTML) || [];
        const variantID = widgetParentContainer.querySelector('[name="id"]')?.value;
        const subRadio = widget.querySelector('.subscription-radio');
        const oneTimeRadio = widget.querySelector('.onetime-radio');
        const currentVariant = variantID ? settings.product.variants.find(item => Number(item.id) === Number(variantID)) : null;
        const productParentContainer = widgetSettingsEl.closest('.main-product-info');
        let sellingPlans = {
            first: null,
            second: null,
            base: null
        };

        if (currentVariant) {
            if (settings?.product?.selected_or_first_available_selling_plan_allocation && settings?.product?.selected_or_first_available_selling_plan_allocation?.price_adjustments) {
                sellingPlans = {
                    first: settings.product.selected_or_first_available_selling_plan_allocation.price_adjustments[0].price,
                    second: settings.product.selected_or_first_available_selling_plan_allocation.price_adjustments[1]?.price || settings.product.selected_or_first_available_selling_plan_allocation.price_adjustments[0].price
                };
            }

            if (settings.product.selected_or_first_available_selling_plan_allocation.price) {
                sellingPlans.base = settings.product.selected_or_first_available_selling_plan_allocation.price;
            }
        }

        if (observer) observer.disconnect();

        if (subRadio) {
            const subTextEl = subRadio.querySelector('.rc-widget__price-info');
            const title = subRadio.querySelector('.rc-radio__subscription');
            const price = subRadio.querySelector('.rc-radio__price');

            if (title) {
                title.innerHTML = title.innerHTML.split(" Save")[0];
            }

            if (price) {
                if (!price.querySelector('.rc-radio__price-free-badge') && !price.querySelector('.rc-radio__price-base') && price.innerHTML) {
                    price.setAttribute('data-price', price.innerHTML.replace("$", "").replaceAll(" ", ""));
                }

                if (settings?.free_ship_sub && !subRadio.querySelector('.rc-radio__price-free-badge')) {
                    price.classList.add('with-free-ship');
                    price.insertAdjacentHTML('beforeend', `<span class="rc-radio__price-free-badge">Free Shipping*</span>`);
                    subRadio.insertAdjacentHTML('beforeend', `<div class="rc-widget__free-ship-divider"></div>`);
                }

                if (currentVariant?.price && price.hasAttribute("data-price") && Number(currentVariant?.price) > Number(price.getAttribute("data-price")) && !subRadio.querySelector('.rc-radio__price-base')) {
                    price.insertAdjacentHTML('afterbegin', `<span class="rc-radio__price-base">$${Number(currentVariant?.price).toFixed(2)}</span>`);
                }
            }

            if (settings?.badge && !subRadio.querySelector(".rc-widget__badge")) {
                subRadio.insertAdjacentHTML('beforeend', `<div class="rc-widget__badge">${settings.badge}</div>`);
            }

            if (sellingPlans.first && sellingPlans.second) {
                const textHtml = `
                        <p>First month subscription charge $${price.hasAttribute("data-price") ? Number(price.getAttribute("data-price")).toFixed(2) : Number(sellingPlans.first).toFixed(2)}</p>
                        <p>$${Number(sellingPlans.second).toFixed(2)} per subscription, billed monthly after first month.</p>
                    `
                if (!subTextEl) {
                    subRadio.insertAdjacentHTML('beforeend', `<div class="rc-widget__price-info">${textHtml}</div>`);
                } else {
                    subTextEl.innerHTML = textHtml;
                }
            }

            if (settings?.text_sub && !subRadio.querySelector('.rc-widget__text')) {
                subRadio.insertAdjacentHTML('beforeend', `<div class="rc-widget__text">${settings.text_sub}</div>`);
            }
        }

        if (oneTimeRadio) {
            const title = oneTimeRadio.querySelector('.rc-radio__label');
            
            if (title && !title.querySelector(".rc-radio__one-time") && !title.querySelector(".rc-radio__price")) {
                const labelName = title.innerHTML.split("$")[0];
                const labelPrice = "$" + title.innerHTML.split("$")[1];

                let freeShip = settings?.free_ship_one ? '<span class="rc-radio__price-free-badge">Free Shipping*</span>' : "";

                title.innerHTML = `<span class="rc-radio__one-time">${labelName}</span>
                    <span class="rc-radio__price${settings?.free_ship_one ? ' with-free-ship' : ''}">${labelPrice}${freeShip}</span>`;
            }
        }

        if (productParentContainer) {
            const freeShipText = productParentContainer.querySelector('.free-shipping-info');
            if (freeShipText) freeShipText.classList.add('is-active');
        }

        if (observer) observer.observe(document.body, { childList: true, subtree: true });
    }
}

function observePriceChanges(widget) {
    const prices = widget.querySelectorAll('.rc-radio__price');
    prices.forEach(price => {
        const observer = new MutationObserver(() => {
            observer.disconnect();
            addCustomHTMLToWidget(widget, observer);
        });

        observer.observe(price, {
            childList: true,
            subtree: true,
            characterData: true
        });
    });
}

function observeRechargeWidgets() {
    const targetNode = document.body;
    const config = { childList: true, subtree: true };

    const callback = function (mutationsList, observer) {
        for (const mutation of mutationsList) {
            if (mutation.type === 'childList') {
                mutation.addedNodes.forEach(node => {
                    if (node.nodeType === 1 && node.classList.contains('rc-widget')) {
                        addCustomHTMLToWidget(node, observer);
                        observePriceChanges(node);
                    } else if (node.nodeType === 1) {
                        const widgets = node.querySelectorAll('.rc-widget');
                        widgets.forEach(widget => {
                            addCustomHTMLToWidget(widget, observer);
                            observePriceChanges(widget);
                        });
                    }
                });
            }
        }
    };

    const observer = new MutationObserver(callback);
    observer.observe(targetNode, config);
    document.querySelectorAll('.rc-widget').forEach(widget => {
        addCustomHTMLToWidget(widget, observer);
        observePriceChanges(widget);
    });
}

observeRechargeWidgets();
/* End Recharge */
